import { render, staticRenderFns } from "./ListaTerritoriosImportados.vue?vue&type=template&id=fa2948b2&lang=pug"
import script from "./ListaTerritoriosImportados.vue?vue&type=script&lang=js"
export * from "./ListaTerritoriosImportados.vue?vue&type=script&lang=js"
import style0 from "./ListaTerritoriosImportados.vue?vue&type=style&index=0&id=fa2948b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports